// extracted by mini-css-extract-plugin
export var container = "_3s-0";
export var icon = "_3s-1";